exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "i[data-v-c57ba470]{margin-right:.5em;font-size:1em}", "", {"version":3,"sources":["/home/runner/work/manager/manager/src/components/purchase/Title.vue"],"names":[],"mappings":"AACA,mBACE,kBAAmB,AACnB,aAAe,CAChB","file":"Title.vue","sourcesContent":["\ni[data-v-c57ba470] {\n  margin-right: .5em;\n  font-size: 1em;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-c57ba470","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/purchase/Title.vue
// module id = 766
// module chunks = 0 4 5 6 8 10